import React from 'react';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { accordionSummary, mainText, mask, secondaryText } from '../CardSummary/CardSummary.sx';
import { Box } from '@mui/material';
import Typography from '@mui/material/Typography';
import AccordionSummary from '@mui/material/AccordionSummary';
import { iconBox, summaryBox, summaryRootBox } from './CreditSummary.sx';
import WalletIcon from 'app/components/Icons/SafeIcon';
import PercentIcon from 'app/components/Icons/PercentIcon';

interface SummaryProps {
  headerText: string;
  creditNum: string;
  totalBalance: number;
  paymentDate: string;
  paymentDate2: string;
  open?: boolean;
  setOpen?: (arg?: boolean) => void;
}
const CreditSummary = (props: SummaryProps) => {
  const { headerText, creditNum, open, setOpen, totalBalance, paymentDate, paymentDate2 } = props;

  return (
    <AccordionSummary
      expandIcon={<ExpandMoreIcon />}
      aria-controls="panel1a-content"
      id="panel1a-header"
      sx={{
        ...accordionSummary,
        // '& .MuiAccordionSummary-expandIconWrapper > .MuiSvgIcon-root > path': {
        //   fill: status.value !== 'closed' ? '#14191F' : '#14191F38',
        // },
      }}
    >
      <Box sx={summaryRootBox}>
        <Box sx={{ borderRadius: '8px' }}>
          <Box sx={{ ...iconBox, backgroundColor: 'rgba(36, 176, 126, 0.08)' }}>
            <PercentIcon color={'secondary'} />
          </Box>
        </Box>
        <Box sx={summaryBox}>
          <Box sx={{ display: 'flex', gap: '4px', flexDirection: 'column' }}>
            <Typography sx={mainText}>{headerText}</Typography>
            <Typography sx={secondaryText}>№ {creditNum}</Typography>
          </Box>
          <Box sx={{ display: 'flex', gap: '4px', flexDirection: 'column' }}>
            {!open && (
              <>
                <Typography sx={{ fontSize: '20px', fontWeight: 600 }}>{totalBalance} ₼</Typography>
                <Typography sx={secondaryText}>
                  {paymentDate} - {paymentDate2}
                </Typography>
              </>
            )}
          </Box>
        </Box>
      </Box>
    </AccordionSummary>
  );
};

export default CreditSummary;
